import { useEffect, useRef } from "react";

/**
 * Exécute une fonction async en toute sécurité.
 * Coupe les setState si le composant est démonté avant la fin.
 * 
 * @param {function} asyncFn - Fonction async à exécuter (reçoit isMounted en argument)
 * @param {array} deps - Tableau de dépendances comme pour useEffect
 * @param {object} options - Options supplémentaires { debug: true }
 */
export default function useSafeAsyncEffect(asyncFn, deps, options = {}) {
    const isMounted = useRef(true);
    const { debug = false } = options;

    useEffect(() => {
        isMounted.current = true;

        if (debug) console.log("🟢 useSafeAsyncEffect MOUNTED");

        const run = async () => {
            await asyncFn(isMounted);
        };

        run();

        return () => {
            if (debug) console.log("🔴 useSafeAsyncEffect UNMOUNTED");
            isMounted.current = false;
        };
    }, deps);
}
